export default __webpack_public_path__ + "static/media/1085.6d357ffc.png";